import apiClient, { unwrap } from './client';

export const tenantApi = {
  getMe: async () => {
    const res = await apiClient.get('/tenants/me');
    return unwrap(res);
  },

  /** Lifetime counts (eggRecords, sales, expenses) for plan-limit usage. */
  getUsage: async () => {
    const res = await apiClient.get('/tenants/me/usage');
    return unwrap(res);
  },

  updateMe: async (data) => {
    const res = await apiClient.put('/tenants/me', data);
    return unwrap(res);
  },

  /**
   * Record a successful Razorpay payment and activate the subscription.
   * @param {{ plan, billingCycle, amount, currency, providerPaymentId, providerOrderId }} data
   */
  subscribe: async (data) => {
    const res = await apiClient.post('/tenants/me/subscribe', data);
    return unwrap(res); // returns updated TenantDto
  },
};
